export default {
  text: '#202020',
  primary: '#77bfdc',
  secondary: 'grey',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#484848'
}
